import { render, staticRenderFns } from "./AssistMaterialHistory.vue?vue&type=template&id=2890a298&scoped=true&lang=pug&"
import script from "./AssistMaterialHistory.vue?vue&type=script&lang=ts&"
export * from "./AssistMaterialHistory.vue?vue&type=script&lang=ts&"
import style0 from "./AssistMaterialHistory.vue?vue&type=style&index=0&id=2890a298&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2890a298",
  null
  
)

export default component.exports